import Webcam from 'webcamjs';

export default (element) => {
    const instance = {};
    // let element;

    instance.startWebcam = () => {
        Webcam.attach(element);
    };

    instance.stopWebcam = () => {
        Webcam.reset();
    };

    instance.snap = (callback) => {
        Webcam.snap(image => {
            callback.call(null, image);
        });
    };

    if (!element) {
        throw new Error('Given element was not found!');
    }

    Webcam.set({
        swfURL: '/scripts/libs/webcam.swf'
    });

    return instance;
};
